import React, { useEffect, useState } from "react";
import {
  Benefit,
  BenefitContainer,
  CardBody,
  CardHeader,
  IconButton,
  Subtitle,
} from "./styles";
import { Item } from "./styles";
import { Benefits } from "./styles";
import { Title } from "./styles";
import { Container } from "./styles";
import Icon from "../../../../../components/Icons";
import Tooltip from "@material-ui/core/Tooltip";
import { useMedia } from "use-media";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";

function CardPlan({ item, blur, data }) {
  const { benefits, title, price } = item.fields;
  const [width, setWidth] = useState(window.innerWidth);
  const mediaPhone = 767;
  const isMobile = useMedia({ maxWidth: 767 });

  const theme = createMuiTheme({
    overrides: {
      MuiTooltip: {
        tooltip: {
          fontFamily: "Open Sans",
          fontWeight: "bold",
          fontSize: "0.875rem",
          textAlign: "center",
          padding: "10px",
          color: "#fff",
          backgroundColor: "#230c87",
          borderRadius: "10px",
          maxWidth: width <= mediaPhone ? "350px" : "400px",
        },
        arrow: {
          color: "#230c87",
        },
      },
    },
  });

  useEffect(() => {
    const handleResizeWindow = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResizeWindow);
    return () => {
      window.removeEventListener("resize", handleResizeWindow);
    };
  }, [setWidth]);

  const standardText = [
    <p className="subtitle-2">12 mensalidades grátis!</p>,
    <p>Após esse período, a partir de R${price} por mês.</p>,
  ];

  return (
    <Container>
      <CardHeader blur={blur}>
        <Title blur={blur}>{title}</Title>
        {isMobile ? <Subtitle blur={blur}>{standardText}</Subtitle> : <p></p>}
      </CardHeader>
      <CardBody blur={blur}>
        {!isMobile && <Subtitle blur={blur}>{standardText}</Subtitle>}
        <Benefits>
          {benefits.map((benefit, index) => (
            <Item
              key={benefit.text}
              style={{
                marginTop: index === 0 ? "8px" : "0",
                padding: isMobile ? "16px 16px 0 8px" : "16px 16px 0 0",
              }}
            >
              <img
                src="/gwmbrasil/assets/check.svg"
                alt="check"
                style={{
                  filter: blur ? "blur(3px)" : "none",
                  paddingLeft: "0.875rem",
                }}
              />
              <BenefitContainer>
                <Benefit bold={benefit.isBold} blur={blur}>
                  <p>{benefit.text}</p>
                </Benefit>
                {benefit.hasTooltip && (
                  <MuiThemeProvider theme={theme}>
                    <Tooltip
                      title={benefit.tooltipText}
                      disableHoverListener={blur}
                      placement={width <= mediaPhone ? "bottom" : "right"}
                      arrow
                    >
                      <IconButton disabled={blur}>
                        <Icon
                          name="Atention"
                          style={{ filter: blur ? "blur(3px)" : "none" }}
                        />
                      </IconButton>
                    </Tooltip>
                  </MuiThemeProvider>
                )}
              </BenefitContainer>
            </Item>
          ))}
        </Benefits>
      </CardBody>
    </Container>
  );
}

export default CardPlan;
